import { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function AppShell({ currentPage, onNavigate, children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <Sidebar
        currentPage={currentPage}
        onNavigate={onNavigate}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <div className="lg:ml-[220px]">
        <TopBar onMenuToggle={() => setMobileOpen(!mobileOpen)} />
        <main className="p-5 lg:p-8 max-w-[1200px] mx-auto">
          <div className="fade-up">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
